import ComponentListService from "../services/ComponentListService";
import { showAlert} from "deskera-ui-library";

export class ComponentManager {
    static updateStatus(param){
        
        var obj = Object.assign({},param['component']);
        obj['isActive'] = !obj['isActive'];
        obj['countryCode'] = 'IN';
        
       return ComponentListService.updateState(obj,obj.id)        
    }
    
    static deleteComponent(params){
        let ids = []
        params.forEach(ele=>{
            ids.push({'componentId':ele.id})
        })
        return ComponentListService.deleteComponent(ids)
    }
    
}